import {ApiParams, ISort} from "../models";

export const getRequestParams = (params: ApiParams | undefined, sort?: ISort | undefined) => {
  if (params && Object.keys(params).length === 1 && (!params.filters || params.filters.length === 0)) {
    params = undefined;
  }
  let requestParams = {};
  if (params && params.filters && params.filters?.length > 0) {
    requestParams = {
      filters: params.filters
    };
  }
  if (params && params.page_size) {
    requestParams = {
      ...requestParams,
      page: params.page,
      page_size: params.page_size
    };
  }
  if (sort) {
    requestParams = {
      ...requestParams,
      order_column: sort.name,
      order_direction: sort.direction
    };
  }
  return requestParams;
}
